/**
 * Hook that returns the set of project IDs on which the given user has a
 * project role. Used to drive the "Vain omat hankkeet" (only-my-projects)
 * filter in the task management page.
 */

import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_PROJECT_ROLES } from "./useProjects";

interface ProjectRoleItem {
  projectId: string;
}

interface ProjectRolesQueryResult {
  projectRoles: {
    items: ProjectRoleItem[];
    totalCount: number;
  };
}

export function useMyProjectIds(userId: string | undefined) {
  const { data, loading } = useQuery<ProjectRolesQueryResult>(GET_PROJECT_ROLES, {
    variables: { filter: { userId }, limit: 500 },
    skip: !userId,
    fetchPolicy: "cache-and-network",
  });

  const myProjectIdSet = useMemo(() => {
    const items = data?.projectRoles?.items || [];
    return new Set(items.map((r) => r.projectId));
  }, [data]);

  return { myProjectIdSet, loading };
}
